module.exports = __webpack_public_path__ + "static/media/ICWLogo.5aa666b1.svg";